/* House of Dhatu — product page behaviour.
   Gallery badge, the inline tax note, and coupon copy.

   No sticky buy bar: it covered the price on iPhone. The bar is switched off
   at the theme setting (Show sticky add to cart) in templates/product.json. */
(function () {
  'use strict';

  var BADGE_TEXT = 'Free shipping';
  var TAX_TEXT = 'incl. of all taxes';

  /* ---- Gallery badge, on every product --------------------------------- */
  function placeBadge() {
    var section = document.querySelector('.shopify-section--main-product');
    if (!section) return;
    if (section.querySelector('.dhatu-badge')) return;

    var images = Array.prototype.slice.call(section.querySelectorAll('img'));
    if (!images.length) return setTimeout(placeBadge, 300);

    var main = images[0];
    var widest = 0;
    images.forEach(function (img) {
      var w = img.getBoundingClientRect().width;
      if (w > widest) { widest = w; main = img; }
    });
    if (widest < 200) return setTimeout(placeBadge, 300);

    var host = main.closest('.product__media, figure, .product-gallery__media, .media, .product-gallery__media-list') || main.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var badge = document.createElement('span');
    badge.className = 'dhatu-badge';
    badge.textContent = section.getAttribute('data-dhatu-badge') || BADGE_TEXT;
    host.appendChild(badge);
  }

  /* ---- Tax note, on the price line -------------------------------------
     The price block is rendered by the theme, so the note is appended into
     it rather than sitting on a line of its own underneath. */
  function placeTaxNote() {
    var list = document.querySelector('.shopify-section--main-product .price-list--product');
    if (!list) return setTimeout(placeTaxNote, 300);
    if (list.querySelector('.dhatu-tax')) return;

    var note = document.createElement('span');
    note.className = 'dhatu-tax';
    note.textContent = TAX_TEXT;
    list.appendChild(note);
  }

  /* ---- Coupon chips ---------------------------------------------------- */
  function copyCode(button) {
    var code = button.getAttribute('data-code');
    if (!code) return;

    var label = button.querySelector('.dhatu-coupon__copy');
    var original = label ? label.textContent : '';

    var done = function () {
      button.classList.add('is-copied');
      if (label) label.textContent = 'Copied';
      var status = document.getElementById('status-announcement');
      if (status) status.textContent = 'Discount code ' + code + ' copied';
      setTimeout(function () {
        button.classList.remove('is-copied');
        if (label) label.textContent = original;
      }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { fallback(code, done); });
    } else {
      fallback(code, done);
    }
  }

  function fallback(code, done) {
    var field = document.createElement('textarea');
    field.value = code;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:absolute;left:-9999px;top:0';
    document.body.appendChild(field);
    field.select();
    try { document.execCommand('copy'); done(); } catch (e) { /* clipboard unavailable */ }
    field.remove();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.dhatu-coupon') : null;
    if (button) copyCode(button);
  });

  /* ---- Rating jumps to the reviews ------------------------------------- */
  document.addEventListener('click', function (event) {
    var rating = event.target.closest ? event.target.closest('.shopify-section--main-product .loox-rating') : null;
    if (!rating) return;
    var reviews = document.getElementById('looxReviews') || document.querySelector('.loox-reviews-default');
    if (reviews) {
      event.preventDefault();
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  function start() {
    placeTaxNote();
    setTimeout(placeBadge, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
